export default "__VITE_ASSET__BI33N6JS__"